import { memo } from 'react';

import { LayoutGridIcon } from '@air/design-icons';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { useMainSideNavItemSelected } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavItemSelected';
import { useSubSideNavBrowseLastPathHref } from '~/components/v2/store/features/workspace/useSubSideNavBrowseLastPathStore';
import { Pathname } from '~/constants/pathname';
import { Routes } from '~/constants/routes';
import { usePrivateAddOnFeatures } from '~/hooks/usePrivateAddOnFeatures';
import { isSearchSubSideNavPathname } from '~/utils/isSearchSubSideNavPathname';

export type MainSideNavItemBoardsProps = {
  pathname: string;
};

export const MainSideNavItemBoards = memo(({ pathname }: MainSideNavItemBoardsProps) => {
  const { libraries } = usePrivateAddOnFeatures();
  const { subSideNavBrowseLastPathHref } = useSubSideNavBrowseLastPathHref(Routes.home);
  const { isSelected } = useMainSideNavItemSelected({
    isRouteSelected:
      isSearchSubSideNavPathname(pathname) ||
      pathname === Pathname.BoardByBoardId ||
      pathname === Pathname.BoardClip ||
      pathname === Pathname.BoardCanvas,
  });

  if (libraries) {
    return null;
  }

  return (
    <MainSideNavItem
      href={subSideNavBrowseLastPathHref}
      icon={LayoutGridIcon}
      id="boards"
      isSelected={isSelected}
      label="Boards"
    />
  );
});

MainSideNavItemBoards.displayName = 'MainSideNavItemBoards';
